import store from "../store";
import axios from "axios";
import resources from "./resources";
import auth from "./auth";
import dashboard from "./dashboard";
import clients from "./clients";
import addresses from "./addresses";
import pets from "./pets";
import diets from "./diets";
import quoteRequests from "./quoteRequests";
import appointmentRequests from "./appointmentRequests";
import quotes from "./quotes";
import orders from "./orders";
import franchises from "./franchises";
import branches from "./branches";
import admins from "./admins";
import roles from "./roles";
import products from "./products";
import productCategories from "./productCategories";
import productVariants from "./productVariants";
import productOrders from "./productOrders";
import shopOrders from "./shopOrders";
import coupons from "./coupons";
import posts from "./posts";
import tags from "./tags";
import shippingWeightTiers from "./shippingWeightTiers";
import referralSettings from "./referralSettings";
import plans from "./plans";
import breeds from "./breeds";
import dietCategories from "./dietCategories";
import dietTemplates from "./dietTemplates";
import reports from "./reports";
import incomes from "./incomes";
import expenses from "./expenses";
import notifications from "./notifications";
import barfheroImport from "./barfheroImport";
import massEmails from "./massEmails";
import paymentAttempts from "./paymentAttempts";
import productionSchedule from "./productionSchedule";
import audit from "./audit";

import { apiUrl } from "../runtimeConfig";

const apiClient = axios.create({
  baseURL: `${apiUrl}`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("authToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

apiClient.interceptors.response.use(response => {
  return response;
}, (error) => {
  if (error.response.status === 401) {
    store.dispatch("logout");
  }

  return Promise.reject(error);
});

resources.setClient(apiClient);
auth.setClient(apiClient);
dashboard.setClient(apiClient);
clients.setClient(apiClient);
addresses.setClient(apiClient);
pets.setClient(apiClient);
diets.setClient(apiClient);
quoteRequests.setClient(apiClient);
appointmentRequests.setClient(apiClient);
quotes.setClient(apiClient);
orders.setClient(apiClient);
franchises.setClient(apiClient);
branches.setClient(apiClient);
admins.setClient(apiClient);
roles.setClient(apiClient);
products.setClient(apiClient);
productCategories.setClient(apiClient);
productVariants.setClient(apiClient);
productOrders.setClient(apiClient);
shopOrders.setClient(apiClient);
coupons.setClient(apiClient);
posts.setClient(apiClient);
tags.setClient(apiClient);
shippingWeightTiers.setClient(apiClient);
referralSettings.setClient(apiClient);
plans.setClient(apiClient);
breeds.setClient(apiClient);
dietCategories.setClient(apiClient);
dietTemplates.setClient(apiClient);
reports.setClient(apiClient);
incomes.setClient(apiClient);
expenses.setClient(apiClient);
notifications.setClient(apiClient);
barfheroImport.setClient(apiClient);
massEmails.setClient(apiClient);
paymentAttempts.setClient(apiClient);
productionSchedule.setClient(apiClient);
audit.setClient(apiClient);

export default {
  resources,
  auth,
  dashboard,
  clients,
  addresses,
  pets,
  diets,
  quoteRequests,
  appointmentRequests,
  quotes,
  orders,
  franchises,
  branches,
  admins,
  roles,
  products,
  productCategories,
  productVariants,
  productOrders,
  shopOrders,
  coupons,
  posts,
  tags,
  shippingWeightTiers,
  referralSettings,
  plans,
  breeds,
  dietCategories,
  dietTemplates,
  reports,
  incomes,
  expenses,
  notifications,
  barfheroImport,
  massEmails,
  paymentAttempts,
  productionSchedule,
  audit,
};
